import Vue from 'vue';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

const miniCartModule = {
  namespaced: true,

  state: {
    items: [],
    bikes: {},
    parts: {},
    cart: {},
  },

  getters: {
    totalItems: (state) => {
      if (isEmpty(state.items)) return state.items.length;

      return state.items.reduce((totalQty, item) => (totalQty += item.qty), 0);
    },
  },

  mutations: {
    setBikes(state, payload) {
      Vue.set(state, 'bikes', payload);
    },

    setParts(state, payload) {
      Vue.set(state, 'parts', payload);
    },

    setCart(state, payload) {
      Vue.set(state, 'cart', payload);
    },

    setItems(state, payload) {
      Vue.set(state, 'items', payload);
    },
  },

  actions: {
    fetchMiniCart(context) {
      axios
        .get('/minicart/')
        .then(({data}) => {
          if (data && data.data) {
            context.commit('setBikes', data.data.bikes || {});
            context.commit('setParts', data.data.parts || {});
            context.commit('setCart', data.data);

            let items = [];

            if (context.state.bikes.products && context.state.parts.products) {
              items = [...context.state.bikes.products, ...context.state.parts.products];
            } else if (context.state.bikes.products) {
              items = [...context.state.bikes.products];
            } else if (context.state.parts.products) {
              items = [...context.state.parts.products];
            }

            context.commit('setItems', items);
          }
        })
        .then(function() {
          return axios.get(`/cart/getRemovedEntries`).then((response) => {
            let feedback = get(response, 'data.meta.feedback');
            let dataItems = get(response, 'data.data');
            let messageValue = get(feedback, 'message.basePropertyValue');
            let messageValueToDisplay;
            if (dataItems && dataItems.length > 0) {
              dataItems.forEach((dataItem, index) => {
                messageValueToDisplay = messageValue.replace('{0}', dataItem);
                window.vm.$notify({
                  type: feedback.type,
                  message: messageValueToDisplay,
                  showClose: true,
                  duration: 0,
                  verticalOffset: 175 + index * 100,
                });
              });
            }
          });
        });

      return true;
    },
  },
};

export default miniCartModule;
